import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader, Center } from "@mantine/core";
import { useAuth } from "./AuthContext.js";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Center h="100vh"><Loader /></Center>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <>{children}</>;
}
